import { FC } from "react";

import { Link as RouterLink } from "react-router-dom";


import { Box, Button, Container, Flex, HStack, Link, useColorModeValue } from "@chakra-ui/react";

import { configs } from "shared/content/Content";
import { LogoType } from "shared/navbar/logo-type/LogoType";
import { bgDark, bgLight } from "theme";
import { AboutPageId, useScroll, WorkPageId , MediaPageId, ServicesPageId , ContactPageId  , LandingPageId, ProfSummaryId, ResumePageId} from "utils/useScroll";
import { MenuDrawer } from "./drawer/Drawer";
import { ColorModeButton } from "shared/color-mode-button/ColorModeButton";

export const Navbar: FC = () => {
    const bg = useColorModeValue(bgLight, bgDark);
    const navItemColor = useColorModeValue("gray.800", "white");
    const currentPage = useScroll();

    const toSection = (section: string) => {
        document.getElementById(section)?.scrollIntoView({ behavior: "smooth" });
    };

    return (
        <Box bg={bg} position="fixed" top="0" w="100%" left="50%" transform="translate(-50%)" zIndex="10">
            <Container py="4" px="4" data-aos="fade-down" data-aos-duration="500" data-aos-delay="100">
                <Flex justifyContent="space-between" alignItems="center">
                    <LogoType text={configs.common.logoType} />
                    <Flex alignItems="center" display={{ base: "none", md: "flex" }}>
                        <HStack spacing="8" mr="6">
                            
                            <Link as={RouterLink} to="/"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === LandingPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(LandingPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Home</Link>

                            <Link as={RouterLink} to="/services"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === ServicesPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(ServicesPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Services</Link>

                            <Link as={RouterLink} to="/work"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === WorkPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(WorkPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Featured Work</Link>

                            <Link as={RouterLink} to="/media"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === MediaPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(MediaPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Articles & Media</Link>

                             {/* <Link as={RouterLink} to="/skills"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === SkillsPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(SkillsPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Skills</Link> */}
                            <Link as={RouterLink} to="/summary"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === ProfSummaryId ? "primary.500" : "transparent"}
                                onClick={() => toSection(ProfSummaryId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Professional Summary</Link>
                        
                            <Link as={RouterLink} to="/resume"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === ResumePageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(ResumePageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Resume</Link>
                            
                            <Link as={RouterLink} to="/contact"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === ContactPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(ContactPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >Contact Me</Link>
                           
                            <Link as={RouterLink} to="/about"
                                variant="link"
                                color={navItemColor}
                                textDecoration="underline"
                                textDecorationThickness="2px"
                                textDecorationColor={currentPage === AboutPageId ? "primary.500" : "transparent"}
                                onClick={() => toSection(AboutPageId)}
                                data-aos="fade"
                                data-aos-delay="200"
                                >About</Link>
                            
                                                   </HStack>
                        <ColorModeButton />
                    </Flex>

                    <MenuDrawer
                        display={{ base: "block", md: "none" }}
                    />
                </Flex>
            </Container>
        </Box>
    );
};
